import Component from '@glimmer/component'
import { service } from '@ember/service'
import type LogoutService from 'teacher-ui-client/services/logout'
import SideNavIconComponent from 'teacher-ui-client/components/side-nav/icon'
import { t } from 'ember-intl'
import { on } from '@ember/modifier'
import handUnfilled from '@images/icons/hand-unfilled.svg'

export class LogOutButton extends Component {
  @service logout!: LogoutService

  <template>
    <li data-test-side-nav-logout class="text-dusty-black-400 px-4 py-3 md:hidden" role="presentation">
      <button
        data-test-sidenav-accordion-label
        type="button"
        class="text-dusty-black-400 hover:text-dusty-black-400 flex w-full cursor-pointer items-center gap-3 text-left text-sm font-medium select-none"
        role="menuitem"
        {{on "click" this.logout.logoutAndRedirect}}
      >
        <SideNavIconComponent @url={{handUnfilled}} @alt="Logout" />
        <span>{{t "sideNav.logout"}}</span>
      </button>
    </li>
  </template>
}

export default LogOutButton
